import { jwtDecode } from 'jwt-decode';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { AuthPayload, AuthState } from './auth.types';

export const AUTH_STORE_KEY = 'auth';

const initialState = {
	idToken: null,
	authUsername: null,
	jwtPayload: null,
	currentUser: null
};

export const useAuthStore = create<AuthState>()(
	persist(
		devtools((set, get) => ({
			...initialState,

			resetStore: () => set(initialState, false, 'auth/resetStore'),

			setIdToken: token => {
				if (get().idToken !== token) {
					set(
						{
							idToken: token,
							jwtPayload: token ? jwtDecode<AuthPayload>(token) : null
						},
						false,
						'auth/setIdToken'
					);
				}
			},

			setAuthUsername: authUsername =>
				set({ authUsername }, false, 'auth/setAuthUsername'),

			setCurrentUser: currentUser => set({ currentUser })
		})),

		{
			name: AUTH_STORE_KEY,
			partialize: state => ({
				authUsername: state.authUsername,
				idToken: state.idToken,
				currentUser: state.currentUser
			})
		}
	)
);
